<template>
    <div class="btn-group">
        <default-button
            flavor="link"
            @click.prevent.stop
        >
            <app-icon
                glyph="map-pin"
            />
        </default-button>
        <default-button
            flavor="link"
            @click.prevent.stop="$emit('click')"
        >
            <app-icon
                glyph="shopping-basket"
            />
        </default-button>
    </div>
</template>

<script type="text/javascript">
import DefaultButton from "@/nibnut/components/Buttons/DefaultButton"
import AppIcon from "@/nibnut/components/AppIcon"

// ASSUMES: singing_telegram is loaded in records cache...

export default {
    name: "SingingTelegramInfoButtons",
    components: {
        DefaultButton,
        AppIcon
    },
    props: {
        telegramId: {
            type: Number,
            required: true
        }
    }
}
</script>
